/*
 * Action types, for strong typing.
 */
export const ADD_MESSAGE = 'ADD_MESSAGE'
export const DISMISS_MESSAGE = 'DISMISS_MESSAGE'
export const CLEAN_MESSAGES = 'CLEAN_MESSAGES'

/*
 * Helper-functions for creating actions.
 */
export function addMessage(message, severity) {
  return { type: ADD_MESSAGE, message: message, severity: severity }
}
export function dismissMessage(id) {
  return { type: DISMISS_MESSAGE, id: id }
}
export function cleanMessages() {
  return { type: CLEAN_MESSAGES }
}



// WEBPACK FOOTER //
// ./src/actions/messages.js